function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component, createRef } from 'react';
import { createSchemaUtils, deepEquals, getChangedFields, getTemplate, getUiOptions, isObject, mergeObjects, NAME_KEY, RJSF_ADDITIONAL_PROPERTIES_FLAG, shouldRender, SUBMIT_BTN_OPTIONS_KEY, toErrorList, UI_GLOBAL_OPTIONS_KEY, UI_OPTIONS_KEY, validationDataMerge } from '@rjsf/utils';
import _forEach from 'lodash/forEach';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _pick from 'lodash/pick';
import _toPath from 'lodash/toPath';
import getDefaultRegistry from "../getDefaultRegistry";
/** The `Form` component renders the outer form and all the fields defined in the `schema` */

var Form = /*#__PURE__*/function (_Component) {
  _inherits(Form, _Component);

  var _super = _createSuper(Form);

  /** Constructs the `Form` from the `props`. Will setup the initial state from the props. It will also call the
   * `onChange` handler if the initially provided `formData` is modified to add missing default values as part of the
   * state construction.
   *
   * @param props - The initial props for the `Form`
   */
  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this, props);
    /** Returns the `formData` with only the elements specified in the `fields` list
     *
     * @param formData - The data for the `Form`
     * @param fields - The fields to keep while filtering
     */

    _this.getUsedFormData = function (formData, fields) {
      // For the case of a single input form
      if (fields.length === 0 && _typeof(formData) !== 'object') {
        return formData;
      } // _pick has incorrect type definition, it works with string[][], because lodash/hasIn supports it


      var data = _pick(formData, fields);

      if (Array.isArray(formData)) {
        return Object.keys(data).map(function (key) {
          return data[key];
        });
      }

      return data;
    };
    /** Returns the list of field names from inspecting the `pathSchema` as well as using the `formData`
     *
     * @param pathSchema - The `PathSchema` object for the form
     * @param [formData] - The form data to use while checking for empty objects/arrays
     */


    _this.getFieldNames = function (pathSchema, formData) {
      var getAllPaths = function getAllPaths(_obj) {
        var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var paths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [[]];
        Object.keys(_obj).forEach(function (key) {
          if (_typeof(_obj[key]) === 'object') {
            var newPaths = paths.map(function (path) {
              return [].concat(_toConsumableArray(path), [key]);
            }); // If an object is marked with additionalProperties, all its keys are valid

            if (_obj[key][RJSF_ADDITIONAL_PROPERTIES_FLAG] && _obj[key][NAME_KEY] !== '') {
              acc.push(_obj[key][NAME_KEY]);
            } else {
              getAllPaths(_obj[key], acc, newPaths);
            }
          } else if (key === NAME_KEY && _obj[key] !== '') {
            paths.forEach(function (path) {
              var formValue = _get(formData, path); // adds path to fieldNames if it points to a value
              // or an empty object/array


              if (_typeof(formValue) !== 'object' || _isEmpty(formValue) || Array.isArray(formValue) && formValue.every(function (val) {
                return _typeof(val) !== 'object';
              })) {
                acc.push(path);
              }
            });
          }
        });
        return acc;
      };

      return getAllPaths(pathSchema);
    };
    /** Returns the `formData` after filtering to remove any extra data not in a form field
     *
     * @param formData - The data for the `Form`
     * @returns The `formData` after omitting extra data
     */


    _this.omitExtraData = function (formData) {
      var _this$state = _this.state,
          schema = _this$state.schema,
          schemaUtils = _this$state.schemaUtils;
      var retrievedSchema = schemaUtils.retrieveSchema(schema, formData);
      var pathSchema = schemaUtils.toPathSchema(retrievedSchema, '', formData);

      var fieldNames = _this.getFieldNames(pathSchema, formData);

      var newFormData = _this.getUsedFormData(formData, fieldNames);

      return newFormData;
    };
    /** Function to handle changes made to a field in the `Form`. This handler receives an entirely new copy of the
     * `formData` along with a new `ErrorSchema`. It will first update the `formData` with any missing default fields and
     * then, if `omitExtraData` and `liveOmit` are turned on, the `formData` will be filtered to remove any extra data not
     * in a form field. Then, the resulting formData will be validated if required. The state will be updated with the new
     * updated (potentially filtered) `formData`, any errors that resulted from validation. Finally the `onChange`
     * callback will be called if specified with the updated state.
     *
     * @param formData - The new form data from a change to a field
     * @param newErrorSchema - The new `ErrorSchema` based on the field change
     * @param id - The id of the field that caused the change
     */


    _this.onChange = function (formData, newErrorSchema, id) {
      var _this$props = _this.props,
          extraErrors = _this$props.extraErrors,
          omitExtraData = _this$props.omitExtraData,
          liveOmit = _this$props.liveOmit,
          noValidate = _this$props.noValidate,
          liveValidate = _this$props.liveValidate,
          onChange = _this$props.onChange;
      var _this$state2 = _this.state,
          schemaUtils = _this$state2.schemaUtils,
          schema = _this$state2.schema;
      var retrievedSchema = _this.state.retrievedSchema;

      if (isObject(formData) || Array.isArray(formData)) {
        var newState = _this.getStateFromProps(_this.props, formData);

        formData = newState.formData;
        retrievedSchema = newState.retrievedSchema;
      }

      var mustValidate = !noValidate && liveValidate;
      var state = {
        formData: formData,
        schema: schema
      };
      var newFormData = formData;

      if (omitExtraData === true && liveOmit === true) {
        newFormData = _this.omitExtraData(formData);
        state = {
          formData: newFormData
        };
      }

      if (mustValidate) {
        var schemaValidation = _this.validate(newFormData, schema, schemaUtils, retrievedSchema);

        var errors = schemaValidation.errors;
        var errorSchema = schemaValidation.errorSchema;
        var schemaValidationErrors = errors;
        var schemaValidationErrorSchema = errorSchema;

        if (extraErrors) {
          var merged = validationDataMerge(schemaValidation, extraErrors);
          errorSchema = merged.errorSchema;
          errors = merged.errors;
        } // Merging 'newErrorSchema' into 'errorSchema' to display the custom raised errors.


        if (newErrorSchema) {
          var filteredErrors = _this.filterErrorsBasedOnSchema(newErrorSchema, retrievedSchema, newFormData);

          errorSchema = mergeObjects(errorSchema, filteredErrors, 'preventDuplicates');
        }

        state = {
          formData: newFormData,
          errors: errors,
          errorSchema: errorSchema,
          schemaValidationErrors: schemaValidationErrors,
          schemaValidationErrorSchema: schemaValidationErrorSchema
        };
      } else if (!noValidate && newErrorSchema) {
        var _errorSchema = extraErrors ? mergeObjects(newErrorSchema, extraErrors, 'preventDuplicates') : newErrorSchema;

        state = {
          formData: newFormData,
          errorSchema: _errorSchema,
          errors: toErrorList(_errorSchema)
        };
      }

      _this.setState(state, function () {
        return onChange && onChange(_objectSpread(_objectSpread({}, _this.state), state), id);
      });
    };
    /**
     * Callback function to handle reset form data.
     * - Reset all fields with default values.
     * - Reset validations and errors
     *
     */


    _this.reset = function () {
      var onChange = _this.props.onChange;

      var newState = _this.getStateFromProps(_this.props, undefined);

      var newFormData = newState.formData;
      var state = {
        formData: newFormData,
        errorSchema: {},
        errors: [],
        schemaValidationErrors: [],
        schemaValidationErrorSchema: {}
      };

      _this.setState(state, function () {
        return onChange && onChange(_objectSpread(_objectSpread({}, _this.state), state));
      });
    };
    /** Callback function to handle when a field on the form is blurred. Calls the `onBlur` callback for the `Form` if it
     * was provided.
     *
     * @param id - The unique `id` of the field that was blurred
     * @param data - The data associated with the field that was blurred
     */


    _this.onBlur = function (id, data) {
      var onBlur = _this.props.onBlur;

      if (onBlur) {
        onBlur(id, data);
      }
    };
    /** Callback function to handle when a field on the form is focused. Calls the `onFocus` callback for the `Form` if it
     * was provided.
     *
     * @param id - The unique `id` of the field that was focused
     * @param data - The data associated with the field that was focused
     */


    _this.onFocus = function (id, data) {
      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus(id, data);
      }
    };
    /** Callback function to handle when the form is submitted. First, it prevents the default event behavior. Nothing
     * happens if the target and currentTarget of the event are not the same. It will omit any extra data in the
     * `formData` in the state if `omitExtraData` is true. It will validate the resulting `formData`, reporting errors
     * via the `onError()` callback unless validation is disabled. Finally, it will add in any `extraErrors` and then call
     * back the `onSubmit` callback if it was provided.
     *
     * @param event - The submit HTML form event
     */


    _this.onSubmit = function (event) {
      event.preventDefault();

      if (event.target !== event.currentTarget) {
        return;
      }

      event.persist();
      var _this$props2 = _this.props,
          omitExtraData = _this$props2.omitExtraData,
          extraErrors = _this$props2.extraErrors,
          noValidate = _this$props2.noValidate,
          onSubmit = _this$props2.onSubmit;
      var newFormData = _this.state.formData;

      if (omitExtraData === true) {
        newFormData = _this.omitExtraData(newFormData);
      }

      if (noValidate || _this.validateFormWithFormData(newFormData)) {
        // There are no errors generated through schema validation.
        // Check for user provided errors and update state accordingly.
        var errorSchema = extraErrors || {};
        var errors = extraErrors ? toErrorList(extraErrors) : [];

        _this.setState({
          formData: newFormData,
          errors: errors,
          errorSchema: errorSchema,
          schemaValidationErrors: [],
          schemaValidationErrorSchema: {}
        }, function () {
          if (onSubmit) {
            onSubmit(_objectSpread(_objectSpread({}, _this.state), {}, {
              formData: newFormData,
              status: 'submitted'
            }), event);
          }
        });
      }
    };
    /** Provides a function that can be used to programmatically submit the `Form` */


    _this.submit = function () {
      if (_this.formElement.current) {
        var submitCustomEvent = new CustomEvent('submit', {
          cancelable: true
        });
        submitCustomEvent.preventDefault();

        _this.formElement.current.dispatchEvent(submitCustomEvent);

        _this.formElement.current.requestSubmit();
      }
    };
    /** Validates the form using the given `formData`. For use on form submission or on programmatic validation.
     * If `onError` is provided, then it will be called with the list of errors.
     *
     * @param formData - The form data to validate
     * @returns - True if the form is valid, false otherwise.
     */


    _this.validateFormWithFormData = function (formData) {
      var _this$props3 = _this.props,
          extraErrors = _this$props3.extraErrors,
          extraErrorsBlockSubmit = _this$props3.extraErrorsBlockSubmit,
          focusOnFirstError = _this$props3.focusOnFirstError,
          onError = _this$props3.onError;
      var prevErrors = _this.state.errors;

      var schemaValidation = _this.validate(formData);

      var errors = schemaValidation.errors;
      var errorSchema = schemaValidation.errorSchema;
      var schemaValidationErrors = errors;
      var schemaValidationErrorSchema = errorSchema;
      var hasError = errors.length > 0 || extraErrors && extraErrorsBlockSubmit;

      if (hasError) {
        if (extraErrors) {
          var merged = validationDataMerge(schemaValidation, extraErrors);
          errorSchema = merged.errorSchema;
          errors = merged.errors;
        }

        if (focusOnFirstError) {
          if (typeof focusOnFirstError === 'function') {
            focusOnFirstError(errors[0]);
          } else {
            _this.focusOnError(errors[0]);
          }
        }

        _this.setState({
          errors: errors,
          errorSchema: errorSchema,
          schemaValidationErrors: schemaValidationErrors,
          schemaValidationErrorSchema: schemaValidationErrorSchema
        }, function () {
          if (onError) {
            onError(errors);
          } else {
            console.error('Form validation failed', errors);
          }
        });
      } else if (prevErrors.length > 0) {
        _this.setState({
          errors: [],
          errorSchema: {},
          schemaValidationErrors: [],
          schemaValidationErrorSchema: {}
        });
      }

      return !hasError;
    };

    if (!props.validator) {
      throw new Error('A validator is required for Form functionality to work');
    }

    _this.state = _this.getStateFromProps(props, props.formData);

    if (_this.props.onChange && !deepEquals(_this.state.formData, _this.props.formData)) {
      _this.props.onChange(_this.state);
    }

    _this.formElement = /*#__PURE__*/createRef();
    return _this;
  }
  /**
   * `getSnapshotBeforeUpdate` is a React lifecycle method that is invoked right before the most recently rendered
   * output is committed to the DOM. It enables your component to capture current values (e.g., scroll position) before
   * they are potentially changed.
   *
   * In this case, it checks if the props have changed since the last render. If they have, it computes the next state
   * of the component using `getStateFromProps` method and returns it along with a `shouldUpdate` flag set to `true` IF
   * the `nextState` and `prevState` are different, otherwise `false`. This ensures that we have the most up-to-date
   * state ready to be applied in `componentDidUpdate`.
   *
   * If `formData` hasn't changed, it simply returns an object with `shouldUpdate` set to `false`, indicating that a
   * state update is not necessary.
   *
   * @param prevProps - The previous set of props before the update.
   * @param prevState - The previous state before the update.
   * @returns Either an object containing the next state and a flag indicating that an update should occur, or an object
   *        with a flag indicating that an update is not necessary.
   */


  _createClass(Form, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps, prevState) {
      if (!deepEquals(this.props, prevProps)) {
        var formDataChangedFields = getChangedFields(this.props.formData, prevProps.formData);
        var isSchemaChanged = !deepEquals(prevProps.schema, this.props.schema); // When formData is not an object, getChangedFields returns an empty array.
        // In this case, deepEquals is most needed to check again.

        var isFormDataChanged = formDataChangedFields.length > 0 || !deepEquals(prevProps.formData, this.props.formData);
        var nextState = this.getStateFromProps(this.props, this.props.formData, // If the `schema` has changed, we need to update the retrieved schema.
        // Or if the `formData` changes, for example in the case of a schema with dependencies that need to
        //  match one of the subSchemas, the retrieved schema must be updated.
        isSchemaChanged || isFormDataChanged ? undefined : this.state.retrievedSchema, isSchemaChanged, formDataChangedFields);
        var shouldUpdate = !deepEquals(nextState, prevState);
        return {
          nextState: nextState,
          shouldUpdate: shouldUpdate
        };
      }

      return {
        shouldUpdate: false
      };
    }
    /**
     * `componentDidUpdate` is a React lifecycle method that is invoked immediately after updating occurs. This method is
     * not called for the initial render.
     *
     * Here, it checks if an update is necessary based on the `shouldUpdate` flag received from `getSnapshotBeforeUpdate`.
     * If an update is required, it applies the next state and, if needed, triggers the `onChange` handler to inform about
     * changes.
     *
     * This method effectively replaces the deprecated `UNSAFE_componentWillReceiveProps`, providing a safer alternative
     * to handle prop changes and state updates.
     *
     * @param _ - The previous set of props.
     * @param prevState - The previous state of the component before the update.
     * @param snapshot - The value returned from `getSnapshotBeforeUpdate`.
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState, snapshot) {
      if (snapshot.shouldUpdate) {
        var nextState = snapshot.nextState;

        if (!deepEquals(nextState.formData, this.props.formData) && !deepEquals(nextState.formData, prevState.formData) && this.props.onChange) {
          this.props.onChange(nextState);
        }

        this.setState(nextState);
      }
    }
    /** Extracts the updated state from the given `props` and `inputFormData`. As part of this process, the
     * `inputFormData` is first processed to add any missing required defaults. After that, the data is run through the
     * validation process IF required by the `props`.
     *
     * @param props - The props passed to the `Form`
     * @param inputFormData - The new or current data for the `Form`
     * @param retrievedSchema - An expanded schema, if not provided, it will be retrieved from the `schema` and `formData`.
     * @param isSchemaChanged - A flag indicating whether the schema has changed.
     * @param formDataChangedFields - The changed fields of `formData`
     * @returns - The new state for the `Form`
     */

  }, {
    key: "getStateFromProps",
    value: function getStateFromProps(props, inputFormData, retrievedSchema) {
      var isSchemaChanged = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var formDataChangedFields = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

      var _a;

      var state = this.state || {};
      var schema = 'schema' in props ? props.schema : this.props.schema;
      var uiSchema = ('uiSchema' in props ? props.uiSchema : this.props.uiSchema) || {};
      var edit = typeof inputFormData !== 'undefined';
      var liveValidate = 'liveValidate' in props ? props.liveValidate : this.props.liveValidate;
      var mustValidate = edit && !props.noValidate && liveValidate;
      var rootSchema = schema;
      var experimental_defaultFormStateBehavior = 'experimental_defaultFormStateBehavior' in props ? props.experimental_defaultFormStateBehavior : this.props.experimental_defaultFormStateBehavior;
      var experimental_customMergeAllOf = 'experimental_customMergeAllOf' in props ? props.experimental_customMergeAllOf : this.props.experimental_customMergeAllOf;
      var schemaUtils = state.schemaUtils;

      if (!schemaUtils || schemaUtils.doesSchemaUtilsDiffer(props.validator, rootSchema, experimental_defaultFormStateBehavior, experimental_customMergeAllOf)) {
        schemaUtils = createSchemaUtils(props.validator, rootSchema, experimental_defaultFormStateBehavior, experimental_customMergeAllOf);
      }

      var formData = schemaUtils.getDefaultFormState(schema, inputFormData);

      var _retrievedSchema = this.updateRetrievedSchema(retrievedSchema !== null && retrievedSchema !== void 0 ? retrievedSchema : schemaUtils.retrieveSchema(schema, formData));

      var getCurrentErrors = function getCurrentErrors() {
        // If the `props.noValidate` option is set or the schema has changed, we reset the error state.
        if (props.noValidate || isSchemaChanged) {
          return {
            errors: [],
            errorSchema: {}
          };
        } else if (!props.liveValidate) {
          return {
            errors: state.schemaValidationErrors || [],
            errorSchema: state.schemaValidationErrorSchema || {}
          };
        }

        return {
          errors: state.errors || [],
          errorSchema: state.errorSchema || {}
        };
      };

      var errors;
      var errorSchema;
      var schemaValidationErrors = state.schemaValidationErrors;
      var schemaValidationErrorSchema = state.schemaValidationErrorSchema;

      if (mustValidate) {
        var schemaValidation = this.validate(formData, schema, schemaUtils, _retrievedSchema);
        errors = schemaValidation.errors; // If retrievedSchema is undefined which means the schema or formData has changed, we do not merge state.
        // Else in the case where it hasn't changed, we merge 'state.errorSchema' with 'schemaValidation.errorSchema.' This done to display the raised field error.

        if (retrievedSchema === undefined) {
          errorSchema = schemaValidation.errorSchema;
        } else {
          errorSchema = mergeObjects((_a = this.state) === null || _a === void 0 ? void 0 : _a.errorSchema, schemaValidation.errorSchema, 'preventDuplicates');
        }

        schemaValidationErrors = errors;
        schemaValidationErrorSchema = errorSchema;
      } else {
        var currentErrors = getCurrentErrors();
        errors = currentErrors.errors;
        errorSchema = currentErrors.errorSchema;

        if (formDataChangedFields.length > 0) {
          var newErrorSchema = formDataChangedFields.reduce(function (acc, key) {
            acc[key] = undefined;
            return acc;
          }, {});
          errorSchema = schemaValidationErrorSchema = mergeObjects(currentErrors.errorSchema, newErrorSchema, 'preventDuplicates');
        }
      }

      if (props.extraErrors) {
        var merged = validationDataMerge({
          errorSchema: errorSchema,
          errors: errors
        }, props.extraErrors);
        errorSchema = merged.errorSchema;
        errors = merged.errors;
      }

      var idSchema = schemaUtils.toIdSchema(_retrievedSchema, uiSchema['ui:rootFieldId'], formData, props.idPrefix, props.idSeparator);
      var nextState = {
        schemaUtils: schemaUtils,
        schema: schema,
        uiSchema: uiSchema,
        idSchema: idSchema,
        formData: formData,
        edit: edit,
        errors: errors,
        errorSchema: errorSchema,
        schemaValidationErrors: schemaValidationErrors,
        schemaValidationErrorSchema: schemaValidationErrorSchema,
        retrievedSchema: _retrievedSchema
      };
      return nextState;
    }
    /** React lifecycle method that is used to determine whether component should be updated.
     *
     * @param nextProps - The next version of the props
     * @param nextState - The next version of the state
     * @returns - True if the component should be updated, false otherwise
     */

  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return shouldRender(this, nextProps, nextState);
    }
    /** Validates the `formData` against the `schema` using the `altSchemaUtils` (if provided otherwise it uses the
     * `schemaUtils` in the state), returning the results.
     *
     * @param formData - The new form data to validate
     * @param schema - The schema used to validate against
     * @param altSchemaUtils - The alternate schemaUtils to use for validation
     */

  }, {
    key: "validate",
    value: function validate(formData) {
      var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.schema;
      var altSchemaUtils = arguments.length > 2 ? arguments[2] : undefined;
      var retrievedSchema = arguments.length > 3 ? arguments[3] : undefined;
      var schemaUtils = altSchemaUtils ? altSchemaUtils : this.state.schemaUtils;
      var _this$props4 = this.props,
          customValidate = _this$props4.customValidate,
          transformErrors = _this$props4.transformErrors,
          uiSchema = _this$props4.uiSchema;
      var resolvedSchema = retrievedSchema !== null && retrievedSchema !== void 0 ? retrievedSchema : schemaUtils.retrieveSchema(schema, formData);
      return schemaUtils.getValidator().validateFormData(formData, resolvedSchema, customValidate, transformErrors, uiSchema);
    }
    /** Renders any errors contained in the `state` in using the `ErrorList`, if not disabled by `showErrorList`. */

  }, {
    key: "renderErrors",
    value: function renderErrors(registry) {
      var _this$state3 = this.state,
          errors = _this$state3.errors,
          errorSchema = _this$state3.errorSchema,
          schema = _this$state3.schema,
          uiSchema = _this$state3.uiSchema;
      var formContext = this.props.formContext;
      var options = getUiOptions(uiSchema);
      var ErrorListTemplate = getTemplate('ErrorListTemplate', registry, options);

      if (errors && errors.length) {
        return _jsx(ErrorListTemplate, {
          errors: errors,
          errorSchema: errorSchema || {},
          schema: schema,
          uiSchema: uiSchema,
          formContext: formContext,
          registry: registry
        });
      }

      return null;
    } // Filtering errors based on your retrieved schema to only show errors for properties in the selected branch.

  }, {
    key: "filterErrorsBasedOnSchema",
    value: function filterErrorsBasedOnSchema(schemaErrors, resolvedSchema, formData) {
      var _this$state4 = this.state,
          retrievedSchema = _this$state4.retrievedSchema,
          schemaUtils = _this$state4.schemaUtils;

      var _retrievedSchema = resolvedSchema !== null && resolvedSchema !== void 0 ? resolvedSchema : retrievedSchema;

      var pathSchema = schemaUtils.toPathSchema(_retrievedSchema, '', formData);
      var fieldNames = this.getFieldNames(pathSchema, formData);

      var filteredErrors = _pick(schemaErrors, fieldNames); // If the root schema is of a primitive type, do not filter out the __errors


      if ((resolvedSchema === null || resolvedSchema === void 0 ? void 0 : resolvedSchema.type) !== 'object' && (resolvedSchema === null || resolvedSchema === void 0 ? void 0 : resolvedSchema.type) !== 'array') {
        filteredErrors.__errors = schemaErrors.__errors;
      } // Removing undefined, null and empty errors.


      var filterNilOrEmptyErrors = function filterNilOrEmptyErrors(errors) {
        _forEach(errors, function (errorAtKey, errorKey) {
          if (_isNil(errorAtKey)) {
            delete errors[errorKey];
          } else if (_typeof(errorAtKey) === 'object' && !Array.isArray(errorAtKey.__errors)) {
            filterNilOrEmptyErrors(errorAtKey);
          }
        });

        return errors;
      };

      return filterNilOrEmptyErrors(filteredErrors);
    }
    /**
     * If the retrievedSchema has changed the new retrievedSchema is returned.
     * Otherwise, the old retrievedSchema is returned to persist reference.
     * -  This ensures that AJV retrieves the schema from the cache when it has not changed,
     *    avoiding the performance cost of recompiling the schema.
     *
     * @param retrievedSchema The new retrieved schema.
     * @returns The new retrieved schema if it has changed, else the old retrieved schema.
     */

  }, {
    key: "updateRetrievedSchema",
    value: function updateRetrievedSchema(retrievedSchema) {
      var _a;

      var isTheSame = deepEquals(retrievedSchema, (_a = this.state) === null || _a === void 0 ? void 0 : _a.retrievedSchema);
      return isTheSame ? this.state.retrievedSchema : retrievedSchema;
    }
    /** Returns the registry for the form */

  }, {
    key: "getRegistry",
    value: function getRegistry() {
      var _a;

      var _this$props5 = this.props,
          customTranslateString = _this$props5.translateString,
          _this$props5$uiSchema = _this$props5.uiSchema,
          uiSchema = _this$props5$uiSchema === void 0 ? {} : _this$props5$uiSchema;
      var schemaUtils = this.state.schemaUtils;

      var _getDefaultRegistry = getDefaultRegistry(),
          fields = _getDefaultRegistry.fields,
          templates = _getDefaultRegistry.templates,
          widgets = _getDefaultRegistry.widgets,
          formContext = _getDefaultRegistry.formContext,
          translateString = _getDefaultRegistry.translateString;

      return {
        fields: _objectSpread(_objectSpread({}, fields), this.props.fields),
        templates: _objectSpread(_objectSpread(_objectSpread({}, templates), this.props.templates), {}, {
          ButtonTemplates: _objectSpread(_objectSpread({}, templates.ButtonTemplates), (_a = this.props.templates) === null || _a === void 0 ? void 0 : _a.ButtonTemplates)
        }),
        widgets: _objectSpread(_objectSpread({}, widgets), this.props.widgets),
        rootSchema: this.props.schema,
        formContext: this.props.formContext || formContext,
        schemaUtils: schemaUtils,
        translateString: customTranslateString || translateString,
        globalUiOptions: uiSchema[UI_GLOBAL_OPTIONS_KEY]
      };
    }
    /** Attempts to focus on the field associated with the `error`. Uses the `property` field to compute path of the error
     * field, then, using the `idPrefix` and `idSeparator` converts that path into an id. Then the input element with that
     * id is attempted to be found using the `formElement` ref. If it is located, then it is focused.
     *
     * @param error - The error on which to focus
     */

  }, {
    key: "focusOnError",
    value: function focusOnError(error) {
      var _this$props6 = this.props,
          _this$props6$idPrefix = _this$props6.idPrefix,
          idPrefix = _this$props6$idPrefix === void 0 ? 'root' : _this$props6$idPrefix,
          _this$props6$idSepara = _this$props6.idSeparator,
          idSeparator = _this$props6$idSepara === void 0 ? '_' : _this$props6$idSepara;
      var property = error.property;

      var path = _toPath(property);

      if (path[0] === '') {
        // Most of the time the `.foo` property results in the first element being empty, so replace it with the idPrefix
        path[0] = idPrefix;
      } else {
        // Otherwise insert the idPrefix into the first location using unshift
        path.unshift(idPrefix);
      }

      var elementId = path.join(idSeparator);
      var field = this.formElement.current.elements[elementId];

      if (!field) {
        // if not an exact match, try finding an input starting with the element id (like radio buttons or checkboxes)
        field = this.formElement.current.querySelector("input[id^=\"".concat(elementId, "\""));
      }

      if (field && field.length) {
        // If we got a list with length > 0
        field = field[0];
      }

      if (field) {
        field.focus();
      }
    }
    /** Programmatically validate the form.  If `omitExtraData` is true, the `formData` will first be filtered to remove
     * any extra data not in a form field. If `onError` is provided, then it will be called with the list of errors the
     * same way as would happen on form submission.
     *
     * @returns - True if the form is valid, false otherwise.
     */

  }, {
    key: "validateForm",
    value: function validateForm() {
      var omitExtraData = this.props.omitExtraData;
      var newFormData = this.state.formData;

      if (omitExtraData === true) {
        newFormData = this.omitExtraData(newFormData);
      }

      return this.validateFormWithFormData(newFormData);
    }
    /** Renders the `Form` fields inside the <form> | `tagName` or `_internalFormWrapper`, rendering any errors if
     * needed along with the submit button or any children of the form.
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          children = _this$props7.children,
          id = _this$props7.id,
          idPrefix = _this$props7.idPrefix,
          idSeparator = _this$props7.idSeparator,
          _this$props7$classNam = _this$props7.className,
          className = _this$props7$classNam === void 0 ? '' : _this$props7$classNam,
          tagName = _this$props7.tagName,
          name = _this$props7.name,
          method = _this$props7.method,
          target = _this$props7.target,
          action = _this$props7.action,
          autoComplete = _this$props7.autoComplete,
          enctype = _this$props7.enctype,
          acceptcharset = _this$props7.acceptcharset,
          acceptCharset = _this$props7.acceptCharset,
          _this$props7$noHtml5V = _this$props7.noHtml5Validate,
          noHtml5Validate = _this$props7$noHtml5V === void 0 ? false : _this$props7$noHtml5V,
          disabled = _this$props7.disabled,
          readonly = _this$props7.readonly,
          formContext = _this$props7.formContext,
          _this$props7$showErro = _this$props7.showErrorList,
          showErrorList = _this$props7$showErro === void 0 ? 'top' : _this$props7$showErro,
          _internalFormWrapper = _this$props7._internalFormWrapper;
      var _this$state5 = this.state,
          schema = _this$state5.schema,
          uiSchema = _this$state5.uiSchema,
          formData = _this$state5.formData,
          errorSchema = _this$state5.errorSchema,
          idSchema = _this$state5.idSchema;
      var registry = this.getRegistry();
      var _SchemaField = registry.fields.SchemaField;
      var SubmitButton = registry.templates.ButtonTemplates.SubmitButton; // The `semantic-ui` and `material-ui` themes have `_internalFormWrapper`s that take an `as` prop that is the
      // PropTypes.elementType to use for the inner tag, so we'll need to pass `tagName` along if it is provided.
      // NOTE, the `as` prop is native to `semantic-ui` and is emulated in the `material-ui` theme

      var as = _internalFormWrapper ? tagName : undefined;
      var FormTag = _internalFormWrapper || tagName || 'form';

      var _getUiOptions = getUiOptions(uiSchema),
          _getUiOptions$SUBMIT_ = _getUiOptions[SUBMIT_BTN_OPTIONS_KEY],
          submitOptions = _getUiOptions$SUBMIT_ === void 0 ? {} : _getUiOptions$SUBMIT_;

      if (disabled) {
        submitOptions = _objectSpread(_objectSpread({}, submitOptions), {}, {
          props: _objectSpread(_objectSpread({}, submitOptions.props), {}, {
            disabled: true
          })
        });
      }

      var submitUiSchema = _defineProperty({}, UI_OPTIONS_KEY, _defineProperty({}, SUBMIT_BTN_OPTIONS_KEY, submitOptions));

      return _jsxs(FormTag, {
        className: className ? className : 'rjsf',
        id: id,
        name: name,
        method: method,
        target: target,
        action: action,
        autoComplete: autoComplete,
        encType: enctype,
        acceptCharset: acceptCharset || acceptcharset,
        noValidate: noHtml5Validate,
        onSubmit: this.onSubmit,
        as: as,
        ref: this.formElement,
        children: [showErrorList === 'top' && this.renderErrors(registry), _jsx(_SchemaField, {
          name: '',
          schema: schema,
          uiSchema: uiSchema,
          errorSchema: errorSchema,
          idSchema: idSchema,
          idPrefix: idPrefix,
          idSeparator: idSeparator,
          formContext: formContext,
          formData: formData,
          onChange: this.onChange,
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          registry: registry,
          disabled: disabled,
          readonly: readonly
        }), children ? children : _jsx(SubmitButton, {
          uiSchema: submitUiSchema,
          registry: registry
        }), showErrorList === 'bottom' && this.renderErrors(registry)]
      });
    }
  }]);

  return Form;
}(Component);

export { Form as default };